import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=146a13da&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('146a13da')) {
      api.createRecord('146a13da', component.options)
    } else {
      api.reload('146a13da', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=146a13da&", function () {
      api.rerender('146a13da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/countries/cities/zones/edit.vue"
export default component.exports